import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./locales/en.json";
import translationTE from "./locales/te.json";
import translationTN from "./locales/ta.json";
import translationHI from "./locales/hi.json";
import translationML from "./locales/ml.json";
import translationKN from "./locales/kn.json";
import translationMR from "./locales/mr.json";
import translationMS from "./locales/ms.json";
import configureStore from "./store";
import { PRIMARY_LANG } from "Common/constant";

// refer span tag orders TS_STYLD_COMPS variable in common constant
const LANGS_SPAN_ORDER = {
  en: 0,
  ta: 1,
  ml: 2,
  // brTag : 3
  hi: 4,
  te: 5,
  kn: 6,
  mr:7,
  my:8
};
const translation_TN_EN = mergeLangs(translationTN, translationEN);
const translation_TE_EN = mergeLangs(translationTE, translationEN);
const translation_HI_EN = mergeLangs(translationHI, translationEN);
const translation_ML_EN = mergeLangs(translationML, translationEN);
const translation_KN_EN = mergeLangs(translationKN, translationEN);
const translation_MR_EN = mergeLangs(translationMR, translationEN);
const translation_MS_EN = mergeLangs(translationMS, translationEN);


const translation_TN_EN_ST = mergeLangWithStyle(
  translationTN,
  translationEN,
  LANGS_SPAN_ORDER.ta
);
const translation_TE_EN_ST = mergeLangWithStyle(
  translationTE,
  translationEN,
  LANGS_SPAN_ORDER.te
);
const translation_HI_EN_ST = mergeLangWithStyle(
  translationHI,
  translationEN,
  LANGS_SPAN_ORDER.hi
);
const translation_ML_EN_ST = mergeLangWithStyle(
  translationML,
  translationEN,
  LANGS_SPAN_ORDER.ml
);
const translation_KN_EN_ST = mergeLangWithStyle(
  translationKN,
  translationEN,
  LANGS_SPAN_ORDER.kn
);
const translation_MR_EN_ST = mergeLangWithStyle(
  translationMR,
  translationEN,
  LANGS_SPAN_ORDER.mr
);

const translation_MS_EN_ST = mergeLangWithStyle(
  translationMS,
  translationEN,
  LANGS_SPAN_ORDER.my
);

const { store } = configureStore();
let defaultStore = store.getState();

function mergeLangs(translate1, translate2) {
  let translation_merge = {};
  for (const key in translate1) {
    if (translate2.hasOwnProperty(key)) {
      // translation_merge[key] = translate1[key] + " / " + translate2[key];
      translation_merge[key] = translate1[key];
    }
  }
  return translation_merge;
}

function mergeLangWithStyle(translate1, translate2, spanOrder) {
  let translation_merge = {};
  for (const key in translate1) {
    if (translate2.hasOwnProperty(key)) {
      // translation_merge[
      //   key
      // ] = `<${spanOrder}>${translate1[key]}</${spanOrder}><3></3><0>${translate2[key]}</0>`;
      translation_merge[
        key
      ] = `<${spanOrder}>${translate1[key]}</${spanOrder}>`;
    }
  }
  return translation_merge;
}

// function mergeTamilWithStyle(translate1, translate2) {
//   let translation_merge = {};
//   for (const key in translate1) {
//     if (translate2.hasOwnProperty(key)) {
//       translation_merge[
//         key
//       ] = `<1>${translate1[key]}</1><3></3><0>${translate2[key]}</0>`;
//     }
//   }
//   return translation_merge;
// }

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // debug: false,
    // fallbackLng: "en",
    fallbackLng:
      defaultStore.loginReducer.user_details.language ?? PRIMARY_LANG,
    resources: {
      en: { translation: translationEN },
      // ta: { translation: translationTN },
      // mal: { translation: translationMAL },
      ta_en: { translation: translation_TN_EN },
      ta_en_st: { translation: translation_TN_EN_ST },
      te_en: { translation: translation_TE_EN },
      te_en_st: { translation: translation_TE_EN_ST },
      hi_en: { translation: translation_HI_EN },
      hi_en_st: { translation: translation_HI_EN_ST },
      ml_en: { translation: translation_ML_EN },
      ml_en_st: { translation: translation_ML_EN_ST },
      kn_en: { translation: translation_KN_EN },
      kn_en_st: { translation: translation_KN_EN_ST },
      mr_en: { translation: translation_MR_EN },
      mr_en_st: { translation: translation_MR_EN_ST },
      ms_en: { translation: translation_MS_EN},
      ms_en_st: { translation: translation_MS_EN_ST },
    },
  });

export default i18n;
